import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { computed } from '@ember/object';
export default ProtoBaseModel.extend({
  allowCardNetworkSounds: attr(Boolean),
  displayValueTranslationKey: computed('allowCardNetworkSounds', function () {
    return this.allowCardNetworkSounds ? 'business.devices.profiles.v2.settings.checkout.paymentSounds.displayValue.on' : 'business.devices.profiles.v2.settings.checkout.paymentSounds.displayValue.off';
  })
});